import { Inmate } from '@reliance/types/models/Inmate';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { formatInmateAVBalance, formatInmateBalance } from '../../format/InmateBalance';
import { formatFullName } from '../../format/FullName';
import RecordRestrictionEditModal from '../RecordRestrictionEditModal';

type HeaderProps = {
  inmate: Inmate & { facilityTitle: string };
  loading: boolean;
  recalculatingBalance: boolean;
  onRefresh(): any;
  onRecalculateBalance(): any;
};

const Header: React.FC<HeaderProps> = (props) => {
  const [showRecordRestrictionsModal, setShowRecordRestrictionsModal] = useState(false);
  const { inmate } = props;

  return (
    <div className="row">
      {showRecordRestrictionsModal &&
        <RecordRestrictionEditModal
          inmate={inmate}
          onClose={(success) => {
            if (success) {
              props.onRefresh();
            }
            setShowRecordRestrictionsModal(false);
          }} />
      }

      <div className="col-xs-12 col-sm-7 col-md-7 col-lg-6">
        <h1 className="page-title txt-color-blueDark">

        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id={`inmate-record-restriction-tooltip`}>
              {inmate.recordRestrictions > 0 ?
                'Record Restrictions In Place' :
                'No Restrictions'
              }
            </Tooltip>
          }>
          <button
            type="button"
            style={{ cursor: 'pointer', border: 'none', padding: 0 }}
            onClick={() => setShowRecordRestrictionsModal(true)}>
            {inmate.recordRestrictions > 0 ?
              <i className="fas fa-sm fa-user-lock txt-color-red" title="Record Restrictions"></i> :
              <i className="fas fa-sm fa-user" />
            }
          </button>
        </OverlayTrigger>&nbsp;

          {formatFullName(inmate)} (#{inmate.account})&nbsp;
          <button
            type="button"
            style={{ cursor: 'pointer', border: 'none', padding: 0 }}
            title="Refresh"
            aria-label="Refresh inmate"
            onClick={() => props.onRefresh()}>
            <i className={`fas fa-sm fa-sync ${props.loading ? 'fa-spin' : ''}`} />
          </button>
          <br/>
          <small>
            <Link to={`/facilities/view/${inmate.facility.id}`}>{inmate.facilityTitle}</Link>
          </small>
        </h1>
      </div>
      <div className="col-xs-12 col-sm-5 col-md-5 col-lg-6">
        <ul className="sparks">
          <li className="sparks-info">
            <h5>Status
            <span className={inmate.status != 'Enabled' ? 'txt-color-red' :'txt-color-greenDark'}>
              {inmate.status}
            </span>
            </h5>
          </li>
          <li className="sparks-info">
            <h5>Phone Status
            <span className={inmate.phoneStatus != 'Enabled' ? 'txt-color-red' :'txt-color-greenDark'}>
              {inmate.phoneStatus}
            </span>
            </h5>
          </li>
          <li className="sparks-info">
            <h5>Texting Status
            <span className={inmate.textStatus != 'Enabled' ? 'txt-color-red' :'txt-color-greenDark'}>
              {inmate.textStatus}
            </span>
            </h5>
          </li>

          <li className="sparks-info">
            <h5>Communication<br/>Policy
            <span className={inmate.communicationTreatment != 'Standard' ?  'txt-color-red' : 'txt-color-greenDark'}>
              {inmate.communicationTreatment}
            </span>
            </h5>
          </li>

          <li className="sparks-info">
            <h5 onClick={props.onRecalculateBalance}>
              Messaging<br/>Balance
              {props.recalculatingBalance &&
                <i className="fas fa-sync fa-spin" style={{ marginLeft: 5 }} />
              }
              <span className={inmate.messagingBalance[0].balance <= 0 ? 'txt-color-blue' : 'txt-color-red'}>
                {formatInmateBalance(inmate)}
              </span>
            </h5>
          </li>

          {inmate.audioVideoBalance &&
            <li className="sparks-info">
              <h5>
                AV<br/>Balance
                <span className={inmate.audioVideoBalance[0].balance <= 0 ? 'txt-color-blue' : 'txt-color-red'}>
                  {formatInmateAVBalance(inmate)}
                </span>
              </h5>
            </li>
          }
        </ul>
      </div>
    </div>
  );
};

export default Header;
